import React, { useState, useEffect } from 'react';
import { useStateValue } from "../../StateProvider";

import SpotifyJam from "../../SpotifyJam";

function SongImage( {AlbumId} ) {
    const [ {token}] = useStateValue();

//AUSGANGSLAGE
                                //mit Objekt
    const [show, setShow] = useState(
        //inital value
       
    //     {

    //     userID: null,
    //     date: null,
    //     time: null,
    //     timestamp: "ddfdf ddfdf",
    //     slots: 1,
    //     appointmentType: null

    // }

{"images" : [
        {
         "height": 640,
         "url": "https://i.scdn.co/image/ab67616d00001e026890d60d32ac3d8a65fa4770",
         "width": 640
        },
       {
         "height": 300,
         "url": "https://i.scdn.co/image/ab67616d00001e026890d60d32ac3d8a65fa4770",
          "width": 300
       },
               {
         "height": 64,
         "url": "https://i.scdn.co/image/ab67616d000048516890d60d32ac3d8a65fa4770",
          "width": 64
         }
       
        ]
        }

  
    
 
    ); //hook example

 

    useEffect(() => {

       //this is where the code runs once 
       //ALBUM BILD HOLEN !!ALBUM ID BESTEHT BEREITS IM TrackForBox!!
       SpotifyJam.getAlbumImage(AlbumId, token).then((response) =>


       setShow( response )
       )
//   {
//    "images": [
//          {
//            "height": 640,
//            "url": "https://i.scdn.co/image/ab67616d0000b2736890d60d32ac3d8a65fa4770",
//            "width": 640
//          },
//          {
//            "height": 300,
//            "url": "https://i.scdn.co/image/ab67616d00001e026890d60d32ac3d8a65fa4770",
//            "width": 300
//          },
//          {
//            "height": 64,
//            "url": "https://i.scdn.co/image/ab67616d000048516890d60d32ac3d8a65fa4770",
//            "width": 64
//          }
//        ]
//      }



//  ) //end setShow


}, [AlbumId, token] );
      // conditions im [] am schluss, leer bedeutet es lädt nur 1X wenn die App Komponente geladen wird





  







 return (


        <div>
       

           <img style={{borderRadius: "7px"}} src={show.images[0].url} width="170px" alt="Album cover" />
      
    
       
        {/* <h2>Zeige useEffect: {show} </h2> */}
        {/* <p>Album ID: {AlbumId} </p><br /> */}
        {/* <p>Token: {token} </p> */}
        </div>
    )
}

export default SongImage;
